import { Formik, Form, FieldArray } from "formik";
import FormWrapper from "components/FormWrapper";
import ResetAndSubmit from "components/ResetAndSubmit";
import * as Yup from "yup";
import OccasionCard from "components/NewCards/OccasionCard";
import NotificationCard from "components/NewCards/NotificationCard";
import { Img } from "components";

const validationSchema = Yup.object({
    countentEngagement: Yup.array()
        .test(
            "at-least-one-selected",
            "At least one countent engagement must be selected",
            (value) => value && value.some((item) => item.checked)
        )
});

const contentEngagement = [
    { title: "Birthday Selfie", description: "Celebrate the joy of birthdays with a heartfelt selfie moment between teacher and student—capturing smiles, memories, and warm wishes in one perfect click.", checked: true },
    { title: "365 days inspiration", description: "Your child will begin every morning with new topic. we send reel, video or audio podcasts every day morining.", checked: true, viewModalButton: true },
    { title: "Child Counsellor Program", description: "We help parents overcome 15 education challenges with practical videos, articles, and podcasts.", checked: true },
    { title: "Unregistered Child Counsellor", description: "Grow your school by showing parents your commitment, so they see where their child belongs.", checked: true },
];



const ContentEngagement = ({ handleNavigate, resetFormData, disableForm }: { handleNavigate, resetFormData?: any, titleAndDesNotRequired?: boolean, disableForm?: boolean }) => {
    // const { globalData } = useContext(AppContext);

    const loadInitialData = () => {
        const savedData = JSON.parse(sessionStorage.getItem("countentEngagement")) || [];
        return savedData.length ? savedData : contentEngagement
    };

    return <Formik
        initialValues={{ filter: "", searchTerm: "", countentEngagement: loadInitialData() }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={(values) => {
            console.log("values.countentEngagement ", values.countentEngagement)
            sessionStorage.setItem("countentEngagement", JSON.stringify(values.countentEngagement));
            handleNavigate(false, "/onboarding/aiManagementHub");
        }}
    >
        {({ values, handleSubmit, resetForm, errors, setFieldValue }) => {

            const handleCheckboxChange = (index) => {
                setFieldValue(
                    `countentEngagement[${index}].checked`,
                    !values.countentEngagement[index].checked
                );
            };

            return <FormWrapper
                title={"Year-Round Engagement = More Admissions"}
                description={"Consistent communication keeps your school top-of-mind. Turn existing parents into advocates—their referrals drive new admissions."}
                childern={<Form onSubmit={handleSubmit}>
                    <div className="rounded-2xl mt-2 space-y-4">
                        <FieldArray name="countentEngagement">
                            {({ push, remove, form }) => (
                                <div className="grid grid-cols-4 gap-4">
                                    {values?.countentEngagement.map((option, index) => <NotificationCard disable={true} key={"asdasdasdasdasdasdasddNotificationCard" + index} element={option} name={`countentEngagement[${index}].checked`} onChange={() => handleCheckboxChange(index)} />)}
                                </div>
                            )}
                        </FieldArray>
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <Img src={"/images/Onboarding/ContentEngagementReferal.svg"} alt="image" className="w-full" />
                            </div>
                            <div>
                                <Img src={"/images/Onboarding/ContentEngagementConnections.svg"} alt="image" className="w-full" />
                            </div>
                        </div>
                    </div>
                    {!disableForm && <ResetAndSubmit
                        submitToolTip={Boolean(errors?.countentEngagement) && "At least one countentEngagement must be selected."}
                        isError={Boolean(errors?.countentEngagement)}
                        resetForm={() => {
                            resetForm();
                            resetFormData();
                        }}
                        submitLabel={"Proceed"}
                    />}
                </Form>}
            />
        }}
    </Formik>
};

export default ContentEngagement;
